import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminAuth from './pages/AdminAuth';
import Viewer from './pages/Viewer';
import AdminDashboard from './pages/AdminDashboard';

// Đường dẫn truy cập trang Admin — KHÔNG hiển thị công khai ở bất kỳ đâu trên UI.
const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || '/mgmt-9x2k7p-portal';

function RequireAuth({ children, type }) {
  const token = localStorage.getItem('token');
  const userType = localStorage.getItem('userType'); // 'user' | 'admin'
  if (!token || userType !== type) {
    return <Navigate to={type === 'admin' ? ADMIN_PATH : '/login'} replace />;
  }
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Route admin dùng đường dẫn bí mật, không có link nào trên UI trỏ tới đây */}
        <Route path={ADMIN_PATH} element={<AdminAuth />} />
        {/* Đã bỏ route /broadcaster: web KHÔNG còn hỗ trợ vai trò Máy Phát */}
        <Route
          path="/viewer"
          element={
            <RequireAuth type="user">
              <Viewer />
            </RequireAuth>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAuth type="admin">
              <AdminDashboard />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}